import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { environment } from 'src/environments/environment';
import { SMRSEntity } from '../Interface/IEntity';
import { AllowedIP } from '../Interface/allowedIP';

@Injectable({
  providedIn: 'root'
})
export class EntityService {

  constructor(private http: HttpClient) { }

  private getHedders(){
    const headers = new HttpHeaders()
        .set('content-type', 'application/json')
        .append('Access-Control-Allow-Origin', '*')
        .append('Access-Control-Allow-Headers', '*')
        .append('Access-Control-Allow-Methods', 'POST,PUT,GET,OPTIONS')
        .append('Accept', 'application/json');
        return headers;
  
  }
  
  getSettings(tenantId: number): Observable<SMRSEntity[]>  {
    try
    {
      const headers = new HttpHeaders()
        .set('content-type', 'application/json')
        .append('Access-Control-Allow-Origin', '*')
        .append('Access-Control-Allow-Headers', '*')
        .append('Access-Control-Allow-Methods', 'POST,PUT,GET,OPTIONS')
        .append('Accept', 'application/json');
  
      return this.http.get<SMRSEntity[]>(`${environment.baseUrl}Entity/GetAll?tenant_id=${tenantId}`
      ,{ headers: headers });
    }
    catch (error) {
      console.error('Here is the error message', error);
    }
  
  }
  createSetting(data: SMRSEntity) {
    return this.http.post(`${environment.baseUrl}Entity`, data);
  }
  
  updateSetting(id: number, data: SMRSEntity) {
    return this.http.put(`${`${environment.baseUrl}Entity`}/${id}`, data);
  }

  uploadBankQRCode(file: File, tenantId: number, accountnumber: string, entityId?: number): Observable<any> {
    const formData = new FormData();
    formData.append('file', file, file.name);
    formData.append('tenant_id', tenantId.toString());
    formData.append('accountnumber', accountnumber);

    if (entityId) {
      formData.append('entityId', entityId.toString());
    }

    return this.http.post<any>(`${environment.baseUrl}Upload/UploadBankQRCode`, formData);
  }
  
  deleteSetting(id: number) {
    return this.http.delete(`${`${environment.baseUrl}Entity`}/${id}`);
  }

  // 1️⃣ Get All
  getAllAllowedIP(): Observable<AllowedIP[]> {
    return this.http.get<AllowedIP[]>(`${environment.baseUrl}AllowedIP`
      ,{ headers: this.getHedders() });
  }

  // 2️⃣ Get By Id
  getAllowedIPById(id: number): Observable<AllowedIP[]> {
    return this.http.get<AllowedIP[]>(`${`${environment.baseUrl}AllowedIP`}/${id}`, 
      { headers: this.getHedders() });
  }

  // 3️⃣ Get By Client
  getAllowedIPByClient(tenantId: number): Observable<AllowedIP[]> {
    return this.http.get<AllowedIP[]>(`${`${environment.baseUrl}AllowedIP`}/client/${tenantId}`, 
      { headers: this.getHedders() });
  }

  // 4️⃣ Insert
  insertAllowedIP(data: AllowedIP): Observable<any> {
    return this.http.post(`${environment.baseUrl}AllowedIP`, data, { headers: this.getHedders() });
  }

  // 5️⃣ Update
  updateAllowedIP(data: AllowedIP): Observable<any> {
    return this.http.put(`${environment.baseUrl}AllowedIP`, data, { headers: this.getHedders() });
  }

  // 6️⃣ Delete
  deleteAllowedIP(id: number): Observable<any> {
    return this.http.delete(`${environment.baseUrl}AllowedIP/${id}`, { headers: this.getHedders() });
  }
  

  
}
